import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import { updateMediaCaption } from '../../api/contentApi';
import {
  updateMediaCaptionRequest,
  updateMediaCaptionSuccess,
  updateMediaCaptionFailure,
} from '../slices/mediaCaptionSlice';

function* updateMediaCaptionSaga(
  action: PayloadAction<{
    campaignId: string;
    restaurantId: string;
    platform: string;
    postCopy: string;
  }>
): Generator<any, void, any> {
  try {
    const { campaignId, restaurantId, platform, postCopy } = action.payload;

    yield call(updateMediaCaption, campaignId, restaurantId, platform, postCopy);

    yield put(updateMediaCaptionSuccess());
  } catch (error: any) {
    yield put(updateMediaCaptionFailure(error.message || 'Failed to update media caption'));
  }
}

export default function* mediaCaptionSaga() {
  yield takeLatest(updateMediaCaptionRequest.type, updateMediaCaptionSaga);
}
